import { PlusCircleOutlined, SearchOutlined } from '@ant-design/icons';
import { useAppDispatch } from '@core/redux/hooks';
import { RootState } from '@core/redux/reducers';
import { newEvent } from '@features/events/store/events.slice';
import { getAllEvents } from '@features/events/store/events.thunk';
import { FilterHeader } from '@organisms';
import { Button, Input, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const STATUS_OPTIONS = [
  { label: 'Ativo', value: '1' },
  { label: 'Inativo', value: '0' },
];

export const FilterEvents: React.FC = () => {
  const dispatch = useAppDispatch();
  const { eventTypeList } = useSelector((state: RootState) => state.events);
  const [filterState, setFilterState] = useState({
    name: '',
    eventType: '',
    statusActivated: undefined,
    identifier: '',
  });

  const handleState = (range: string, value: any) => {
    setFilterState({ ...filterState, [range]: value });
  };

  const normalizeStatus = (status: string | undefined) => {
    if (status === '1') {
      return 'true';
    }
    if (status === '0') {
      return 'false';
    }
    return undefined;
  };

  useEffect(() => {
    dispatch(
      getAllEvents({
        name: filterState.name
          ? { iLike: `$${filterState.name.replace(' ', '$')}$` }
          : undefined,
        eventTypeId: filterState.eventType || undefined,
        statusActivated: normalizeStatus(filterState.statusActivated),
      })
    );
  }, [filterState]);

  const handleClickAddBanner = () => {
    dispatch(newEvent());
  };

  return (
    <FilterHeader
      customFilter={[
        <Select
          allowClear
          dropdownMatchSelectWidth
          placeholder={'Status'}
          options={STATUS_OPTIONS}
          onChange={value => handleState('statusActivated', value)}
        />,
        <Select
          allowClear
          dropdownMatchSelectWidth
          placeholder={'Tipo de evento'}
          options={eventTypeList?.map(eventType => ({
            value: eventType.id,
            label: eventType.name,
          }))}
          onChange={value => handleState('eventType', value)}
        />,

        <Input
          value={filterState.name}
          placeholder={'Buscar pelo nome ou identificador'}
          onChange={evt => handleState('name', evt.target.value)}
          suffix={<SearchOutlined />}
        />,
      ]}
      buttonList={[
        <Button
          icon={<PlusCircleOutlined />}
          type='primary'
          onClick={handleClickAddBanner}
        >
          Adicionar Evento
        </Button>,
      ]}
    />
  );
};
